module.exports = __webpack_public_path__ + "img/palapas.d2286487.svg";